import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=4fb99ea2&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "../../utils/commen.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./contact.vue?vue&type=style&index=1&id=4fb99ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb99ea2",
  null
  
)

export default component.exports